import React from 'react'

import type { ComponentProps } from 'react'

/**
 * The drawing lives one dynamic import away.
 *
 * echarts and zrender weigh about a megabyte between them, and a static import
 * anywhere in the app's graph puts that megabyte in the wave every session
 * waits for — including the sessions that never open a screen with a chart.
 * Behind `lazy` it is fetched when a chart is actually rendered.
 */
const Inner = React.lazy(async () => {
  const module_ = await import('./trade-holders-chart-drawing')
  return { default: module_.TradeHoldersChart }
})

export const TradeHoldersChart = (props: ComponentProps<typeof Inner>) => (
  <React.Suspense fallback={undefined}>
    <Inner {...props} />
  </React.Suspense>
)
